// DailySchedule.js
import React, { useState } from 'react';
import './KitchenDashboard.css';
import { useKitchenData } from './Context/KitchenDataContext';
import KitchenSidebar from './KitchenSidebar';

const DailySchedule = () => {
  const { patients, getScheduleForDate, menuItems } = useKitchenData();
  const [date, setDate] = useState(new Date());
  
  const dateStr = date.toISOString().split('T')[0];
  const schedule = getScheduleForDate(dateStr);
  const scheduleTimes = ['08:00', '10:30', '13:00', '16:00', '20:00'];
  const timeLabels = ['08:00', '10:30', '01:00pm', '4:00pm', '8:00pm'];

  const changeDay = (delta) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + delta);
    setDate(newDate);
  };

  const legend = Object.values(menuItems).map(item => ({
    code: item.code,
    name: item.name
  }));

  return (
    <div className="kitchen-layout">
      <KitchenSidebar />
      <div className="kitchen-root col-10">
        <div className="kitchen-header" style={{marginBottom:8, alignItems:'center'}}>
          <div>
            <h1 className="kh-title">Daily Schedule</h1>
            <div className="kh-date">
              Meal schedule for {date.toLocaleDateString('en-US', { 
                weekday:'long', 
                month:'long', 
                day:'numeric' 
              })}
            </div>
          </div>
          <div className="ds-controls">
            <button className="btn-nav" onClick={()=>changeDay(-1)}>◀</button>
            <input 
              type="date" 
              className="kh-search" 
              value={dateStr} 
              onChange={(e)=>setDate(new Date(e.target.value))} 
            />
            <button className="btn-nav" onClick={()=>changeDay(1)}>▶</button>
          </div>
        </div>

        <div className="kh-panel">
          <div className="ds-table">
            <div className="ds-header">
              <div className="ds-cell sticky">Patient</div>
              <div className="ds-cell sticky">Room</div>
              {scheduleTimes.map((time, index) => (
                <div key={time} className="ds-cell head">
                  {timeLabels[index]}
                </div>
              ))}
            </div>
            {patients.map(patient => (
              <div key={patient.id} className="ds-row">
                <div className="ds-cell sticky name">{patient.name}</div>
                <div className="ds-cell sticky room">{patient.room}</div>
                {scheduleTimes.map(time => {
                  const patientSchedule = schedule[patient.id] || {};
                  const foodCode = patientSchedule[time] || '';
                  const menuItem = menuItems[foodCode];
                  
                  return (
                    <div key={time} className="ds-cell">
                      <div className="ds-meal">
                        {menuItem ? menuItem.name : (foodCode ? 'Unknown' : '-')}
                      </div>
                      <div className="ds-code">{foodCode}</div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        <div className="kh-panel" style={{marginTop:16}}>
          <div className="kh-panel-title">Food Code Legend</div>
          <div className="legend">
            {legend.map(l => (
              <div key={l.code} className="legend-item">
                <span className="pd-chip">{l.code}</span> {l.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailySchedule;